import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "gatsby";

const StyledDropdownNav = styled.nav`
  position: relative;

  ul {
    position: absolute;
    top: ${(props) => (props.scrolled ? "1.9rem" : "2.9rem")};
    list-style: none;
    background-color: var(--white);
    text-transform: none;
    display: flex;
    flex-direction: column;
    transition: max-height 0.5s ease-out;
    max-height: ${(props) => (props.isOpen ? "40rem" : "0px")};
    overflow: hidden;
    box-shadow: var(--gray-shadow);

    li {
      margin: 0.875rem 2rem;

      &:first-child {
        margin-top: 2rem;
      }

      &:last-child {
        margin-bottom: 2.875rem;
      }
    }
  }
`;

const DropdownNav = ({ isOpen, links, scrolled }) => {
  const [isSecondaryLinks, setIsSecondaryLinks] = useState(false);

  useEffect(() => {
    const delayEffect = setTimeout(() => {
      if (!isOpen) {
        setIsSecondaryLinks(false);
      }
    }, 600);

    return () => clearTimeout(delayEffect);
  }, [isOpen]);

  const secondaryLinks = links
    .filter((link) => link.links)
    .map((link) => link.links)[0];

  return (
    <StyledDropdownNav isOpen={isOpen} scrolled={scrolled}>
      <ul>
        {(isSecondaryLinks ? secondaryLinks : links).map((link) => (
          <li key={link.text} className="poppins-300 body-sm">
            {link.href ? (
              <Link to={link.href}>– {link.text}</Link>
            ) : (
              <div onClick={() => setIsSecondaryLinks(true)}>– {link.text}</div>
            )}
          </li>
        ))}
      </ul>
    </StyledDropdownNav>
  );
};

export default DropdownNav;
